import { Injectable } from '@angular/core';
import { LuceneExpression } from 'lucene';

import { DatacenterFiltersConfiguration } from '../datacenter/datacenter-filters-configuration';
import { DatacenterType } from '../models/datacenter-aggrid-view';
import { FilterType } from '../models/datacenter-filters';
import { ListFilter } from '../models/filter';

@Injectable({ providedIn: 'root' })
export class ListFilterService {
	private readonly currentFilters = new Map<string, ListFilter>();
	private _filterToEdit: {
		filterState: ListFilter;
		datacenterType: DatacenterType;
	} | undefined;

	constructor(private readonly defaultFilterConfiguration: DatacenterFiltersConfiguration) {}

	get filterToEdit() {
		return this._filterToEdit;
	}

	set filterToEdit(
		filterToEdit: {
			filterState: ListFilter;
			datacenterType: DatacenterType;
		} | undefined
	) {
		this._filterToEdit = filterToEdit;
	}

	setCurrentFilter(userFilter: ListFilter) {
		this.currentFilters.set(userFilter.datacenterType, userFilter);
	}

	getAppliedFilters(datacenterType: DatacenterType) {
		return this.currentFilters.get(datacenterType);
	}

	getPreparedFilters(currentFilters: ListFilter) {
		const resultFilter: FilterType[] = [];
		if (!currentFilters.filterState) {
			return resultFilter;
		}
		const { filterState } = currentFilters;
		for (const item of filterState) {
			const filterType = this.defaultFilterConfiguration.getFilter(item.id, currentFilters.datacenterType);
			if (!filterType) {
				continue;
			}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
			filterType.addValues(<any> item.values);
			resultFilter.push(filterType);
		}

		return resultFilter;
	}

	getLuceneFromAllFilters(currentFilters: ListFilter) {
		const allFilters = this.getPreparedFilters(currentFilters);
		let result: LuceneExpression | undefined;
		for (const filter of allFilters) {
			const newNode = filter.getLuceneExpression();
			if (newNode && 'parenthesized' in newNode) {
				newNode.parenthesized = true;
			}
			result = this.createLuceneNode(result, newNode);
		}

		return result;
	}

	private createLuceneNode(currentNode: LuceneExpression | undefined, newNode: LuceneExpression | undefined) {
		if (!newNode) {
			return currentNode;
		}
		return !currentNode ? newNode
			: {
				left: currentNode,
				operator: 'AND',
				parenthesized: true,
				right: newNode
			};
	}
}
